export default {
    title_list: 'Услуги консьержа',
    title_page: 'Услуга консьержа',
    title_create_page: 'Создать услугу консьержа',
    title_edit_page: 'Изменить услугу консьержа',

    filter: {
        labels: {
            user_id: 'Пользователь',
            braintree_id: 'Braintree ID',
        }
    },

    table: {
        labels: {
            id: 'ID',
            created_at: 'Дата',
            user_id: 'Пользователь',
            payment: 'Платеж',
            status: 'Статус',
        }
    },

    buttons: {

    },

    form: {
        user_id: 'Пользователь',
        braintree_id: 'Braintree ID',
        created_at: 'Дата',
        status: 'Статус',
    },
}
